<div class="policy-category disabled">

  <div class="policy-item">

    <i class="policy-number">1</i>
    <div class="default-text large" [innerHTML]="textCopy.firstTitle"></div>
    <div class="default-text" [innerHTML]="textCopy.firstSubtitle"></div>

    <contraventions-question [valuesSelected]="contraventionsQuestion.valuesSelected"
                             [options]="contraventionsQuestion.options"
                         (selectAnswer)="onContraventionsQuestionSelected($event)"></contraventions-question>
    
  </div>

  <div class="policy-item">
    <i class="policy-number">2</i>
    <radio-question [data]="secondRadioQuestion.data" [active]="secondRadioQuestion.active"
                    [valueSelected]="secondRadioQuestion.valueSelected"
                    (selectAnswer)="onSecondRadioQuestionSelected($event)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">3</i>
    <select-question [data]="thirdSelectQuestion.data" [active]="secondRadioQuestion.valueSelected === 'y'"
               [valueSelected]="thirdSelectQuestion.valueSelected"
               (selectAnswer)="onThirdSelectQuestionSelected($event)"></select-question>
  </div>

  <div class="policy-item">

    <i class="policy-number">4</i>
    <div class="default-text large" [innerHTML]="textCopy.fourthTitle"></div>
    <div class="default-text" [innerHTML]="textCopy.fourthSubtitle"></div>

    <div class="default-text"><strong>{{textCopy.badgeTitle}}</strong></div>
    <multiple-select-question [data]="badgeMultipleQuestions.data" [active]="secondRadioQuestion.valueSelected === 'y'"
                              [valuesSelected]="badgeMultipleQuestions.valuesSelected"
                              (selectAnswer)="onBadgeMultipleQuestionsSelected($event)"></multiple-select-question>

    <div class="default-text"><strong>{{textCopy.clockTitle}}</strong></div>
    <multiple-select-question [data]="clockMultipleQuestions.data" [active]="secondRadioQuestion.valueSelected === 'y'"
                              [valuesSelected]="clockMultipleQuestions.valuesSelected"
                              (selectAnswer)="onClockMultipleQuestionsSelected($event)"></multiple-select-question>

  </div>

  <div class="policy-item">

    <i class="policy-number">5</i>
    <radio-question [data]="furtherInfoRadioQuestion.data" [active]="furtherInfoRadioQuestion.active"
                    [valueSelected]="furtherInfoRadioQuestion.valueSelected"
                    (selectAnswer)="onFurtherInfoRadioQuestionSelected($event)"></radio-question>
    <div class="default-text" [innerHTML]="textCopy.furtherInfoParagraph"></div>

    <div class="default-text" [innerHTML]="textCopy.furtherInfoTextarea"></div>
    <textarea class="app-textarea" [(ngModel)]="furtherInfoTextarea"></textarea>

  </div>

  <br />
  <div class="submit-layer">
    <input aria-label=""  type="submit" class="app-submit" value="Save"
           (click)="submitPolicyCategory()" />
  </div>

</div>
